import React, { useState, useRef } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Row,
  Col,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { useTranslation } from 'react-i18next';

const API_BASE = import.meta.env.VITE_APP_API_URL;

const RegistroCuentaPaso3VerifCodMail = ({
  onNext,
  onBack,
  boxRadius = '0.5rem'
}) => {
  const [digits, setDigits] = useState(Array(6).fill(''));
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const inputsRef = useRef([]);

  // i18n – namespace "activation"
  const { t } = useTranslation('activation');

  const handleChange = (idx, e) => {
    const val = e.target.value.replace(/[^0-9]/g, '').slice(-1);
    const next = [...digits];
    next[idx] = val;
    setDigits(next);
    if (val && idx < 5) inputsRef.current[idx + 1].focus();
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace' && !digits[idx] && idx > 0) {
      inputsRef.current[idx - 1].focus();
    }
  };

  const handleVerify = async () => {
    const code = digits.join('');
    if (code.length < 6) {
      setError(t('step3.errors.codeRequired'));
      return;
    }
    setError(null);
    setLoading(true);

    try {
      const url = `${API_BASE}/registro/activacion/${encodeURIComponent(code)}`;
      const resp = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({})
      });

      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);

      const result = await resp.json();
      if (result.succeeded) {
        // muestra el modal de éxito
        setShowSuccess(true);
      } else {
        setError(result.message || t('step3.errors.invalidCode'));
      }
    } catch {
      setError(t('step3.errors.connectionError'));
    } finally {
      setLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    // una vez que el usuario cierra el modal, avanza
    onNext(digits.join(''));
  };

  return (
    <>
      <Card className="shadow-sm">
        <CardHeader tag="h4" className="card-header-primary">
          {t('step3.title')}
        </CardHeader>
        <CardBody>
          <p>{t('step3.instructions')}</p>
          <Row className="justify-content-center mb-3">
            {digits.map((d, i) => (
              <Col xs="2" sm="1" key={i} className="px-1">  {/* Ajusta el ancho en pantallas pequeñas */}
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength="1"
                  className="form-control text-center fs-4"
                  value={d}
                  onChange={e => handleChange(i, e)}
                  onKeyDown={e => handleKeyDown(i, e)}
                  ref={el => (inputsRef.current[i] = el)}
                  style={{
                    borderRadius: boxRadius,
                    backgroundColor: '#fff',
                    color: '#000',
                    width: '100%',
                    height: '3.5rem',
                    padding: 0,
                    minWidth: '40px',  // Ancho mínimo para evitar que se estreche demasiado
                    fontSize: 'clamp(1.2rem, 3vw, 1.8rem)',  // Tamaño de fuente responsivo
                  }}
                />
              </Col>
            ))}
          </Row>


          {error && <Alert color="danger">{error}</Alert>}

          <div className="d-flex justify-content-between mt-4">
            <Button color="secondary" onClick={onBack} disabled={loading}>
              {t('common.previous')}
            </Button>
            <Button color="primary" onClick={handleVerify} disabled={loading}>
              {loading ? t('step3.verifying') : t('step3.verifyButton')}
            </Button>
          </div>
        </CardBody>
      </Card>

      {/* Modal de éxito */}
      <Modal isOpen={showSuccess} centered>
        <ModalHeader>{t('step3.modal.title')}</ModalHeader>
        <ModalBody>
          {t('step3.modal.body')}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSuccessClose}>
            {t('step3.modal.continue')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default RegistroCuentaPaso3VerifCodMail;
